import DatePicker from "component/datePicker/datePicker"
import Checkbox from "component/checkbox/checkbox"
import { SeasonModel } from "../../models"
import { SeasonDateRangeLocal } from "./hotelContractTypes"
import { toTitleCase } from "util/textcase"

interface SeasonDateRangesProps {
    seasons: SeasonModel[]
    seasonDateRanges: SeasonDateRangeLocal[]
    contractStartDate: string
    contractEndDate: string
    onDateRangeChange: (rangeId: string, field: "start_date" | "end_date", value: string) => void
    onAddDateRange: (seasonId: string) => void
    onDeleteDateRange: (rangeId: string) => void
    onRemainingDatesChange: (seasonIndex: number, checked: boolean) => void
    // onCompulsoryMealChange: (seasonIndex: number, checked: boolean) => void
    onCreateNewRange: (seasonId: string, startDate: string) => void
    getDateRangeErrors: (rangeId: string, startDate: string, endDate: string) => string[]
    getSeasonRowColor: (seasonIndex: number) => string
    showValidationErrors: boolean
}

const SeasonDateRanges = ({
    seasons,
    seasonDateRanges,
    contractStartDate,
    contractEndDate,
    onDateRangeChange,
    onAddDateRange,
    onDeleteDateRange,
    onRemainingDatesChange,
    // onCompulsoryMealChange,
    onCreateNewRange,
    getDateRangeErrors,
    getSeasonRowColor,
    showValidationErrors,
}: SeasonDateRangesProps) => {
    return (
        <>
            <b>Add Date Range For Each Season</b>

            <div className="season-date-table-container">
                <table className="season-date-table">
                    <thead>
                        <tr>
                            {/* <th className="compulsory-meal-header">
                                <span>Compulsory</span>
                                <span>Meal</span>
                            </th> */}
                            <th>Season</th>
                            <th className="remaining-dates-header">
                                <span>Remaining</span>
                                <span>Dates</span>
                            </th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {seasons.map((season, seasonIndex) => {
                            const seasonRanges = seasonDateRanges.filter((range) => range.season_id === season.season_id)
                            const rowColor = getSeasonRowColor(seasonIndex)
                            const hasMultipleRows = seasonRanges.length > 1

                            // If no date ranges exist, show empty row
                            if (seasonRanges.length === 0) {
                                return (
                                    <tr key={season.season_id} style={{ backgroundColor: rowColor }}>
                                        {/* <td className="compulsory-meal-cell">
                                            <Checkbox
                                                checked={false}
                                                onChange={(checked) => onCompulsoryMealChange(seasonIndex, checked)}
                                            />
                                        </td> */}
                                        <td className="season-name-cell">{toTitleCase(season.season_name) || ""}</td>
                                        <td className="remaining-dates-cell">
                                            <Checkbox
                                                checked={season.flag_remaining_season}
                                                disabled={
                                                    season.flag_remaining_season === false &&
                                                    seasons.some((s) => s.flag_remaining_season)
                                                }
                                                onChange={(checked) => onRemainingDatesChange(seasonIndex, checked)}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                label=""
                                                placeholder="dd-mm-yyyy"
                                                value=""
                                                minDate={contractStartDate || undefined}
                                                maxDate={contractEndDate || undefined}
                                                disabled={season.flag_remaining_season}
                                                required={!season.flag_remaining_season}
                                                error={
                                                    showValidationErrors && !season.flag_remaining_season
                                                        ? "Required"
                                                        : undefined
                                                }
                                                onChange={(date) => {
                                                    if (date) {
                                                        onCreateNewRange(season.season_id || "", date)
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                label=""
                                                placeholder="dd-mm-yyyy"
                                                value=""
                                                onChange={() => {}}
                                                disabled={true}
                                                required={!season.flag_remaining_season}
                                                error={
                                                    showValidationErrors && !season.flag_remaining_season
                                                        ? "Required"
                                                        : undefined
                                                }
                                            />
                                        </td>
                                        <td className="actions-cell">
                                            <button
                                                    type="button"
                                                    className="add-range-button"
                                                    onClick={() => onAddDateRange(season.season_id || "")}
                                                    disabled={season.flag_remaining_season}
                                                >
                                                    +
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }

                            return seasonRanges.map((range, rangeIndex) => {
                                const errors = getDateRangeErrors(range.range_id, range.start_date, range.end_date)
                                const hasErrors = Array.isArray(errors) && errors.length > 0

                                // Determine error message for start date
                                const startDateError =
                                    showValidationErrors && !season.flag_remaining_season
                                        ? !range.start_date
                                            ? "Required"
                                            : hasErrors
                                                ? errors.filter((e) => typeof e === "string").join(", ")
                                                : undefined
                                        : undefined

                                // Determine error message for end date
                                const endDateError =
                                    showValidationErrors && !season.flag_remaining_season
                                        ? !range.end_date
                                            ? "Required"
                                            : hasErrors
                                                ? errors.filter((e) => typeof e === "string").join(", ")
                                                : undefined
                                        : undefined

                                return (
                                    <tr key={range.range_id} style={{ backgroundColor: rowColor }}>
                                        {rangeIndex === 0 && (
                                            <>
                                                {/* <td className="compulsory-meal-cell" rowSpan={seasonRanges.length}>
                                                    <Checkbox
                                                        checked={false}
                                                        onChange={(checked) => onCompulsoryMealChange(seasonIndex, checked)}
                                                    />
                                                </td> */}
                                                <td className="season-name-cell" rowSpan={seasonRanges.length}>
                                                    {toTitleCase(season.season_name) || ""}
                                                </td>
                                                <td className="remaining-dates-cell" rowSpan={seasonRanges.length}>
                                                    <Checkbox
                                                        checked={season.flag_remaining_season}
                                                        disabled={
                                                            season.flag_remaining_season === false &&
                                                            seasons.some((s) => s.flag_remaining_season)
                                                        }
                                                        onChange={(checked) =>
                                                            onRemainingDatesChange(seasonIndex, checked)
                                                        }
                                                    />
                                                </td>
                                            </>
                                        )}
                                        <td>
                                            <DatePicker
                                                label=""
                                                placeholder="dd-mm-yyyy"
                                                value={range.start_date}
                                                minDate={contractStartDate || undefined}
                                                maxDate={contractEndDate || undefined}
                                                disabled={season.flag_remaining_season}
                                                required={!season.flag_remaining_season}
                                                error={startDateError}
                                                onChange={(date) => onDateRangeChange(range.range_id, "start_date", date)}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                label=""
                                                placeholder="dd-mm-yyyy"
                                                value={range.end_date}
                                                minDate={range.start_date || contractStartDate || undefined}
                                                maxDate={contractEndDate || undefined}
                                                disabled={season.flag_remaining_season || !range.start_date}
                                                required={!season.flag_remaining_season}
                                                error={endDateError}
                                                onChange={(date) => onDateRangeChange(range.range_id, "end_date", date)}
                                            />
                                        </td>
                                        <td className="actions-cell">
                                            <button
                                                type="button"
                                                className="add-range-button"
                                                onClick={() => onAddDateRange(season.season_id || "")}
                                                disabled={season.flag_remaining_season}
                                            >
                                                +
                                            </button>
                                            {/* Only show "-" button when there are multiple rows and not remaining season */}
                                            {hasMultipleRows && !season.flag_remaining_season && (
                                                <button
                                                    type="button"
                                                    className="remove-range-button"
                                                    onClick={() => onDeleteDateRange(range.range_id)}
                                                >
                                                    -
                                                </button>

                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default SeasonDateRanges
